export default __webpack_public_path__ + "static/media/team-photo-2014.3b2f2e03.jpg";